import React from 'react';

export const PacmanLoading: React.FC = () => {
  return (
    <div className='pacman-loading'>
      <div className='pacman'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
